/*
 * jQuery doTimeout: Like setTimeout, but better! - v1.0 - 3/3/2010
 * http://benalman.com/projects/jquery-dotimeout-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function($){var a={},c="doTimeout",d=Array.prototype.slice;$[c]=function(){return b.apply(window,[0].concat(d.call(arguments)))};$.fn[c]=function(){var f=d.call(arguments),e=b.apply(this,[c+f[0]].concat(f));return typeof f[0]==="number"||typeof f[1]==="number"?this:e};function b(l){var m=this,h,k={},g=l?$.fn:$,n=arguments,i=4,f=n[1],j=n[2],p=n[3];if(typeof f!=="string"){i--;f=l=0;j=n[1];p=n[2]}if(l){h=m.eq(0);h.data(l,k=h.data(l)||{})}else{if(f){k=a[f]||(a[f]={})}}k.id&&clearTimeout(k.id);delete k.id;function e(){if(l){h.removeData(l)}else{if(f){delete a[f]}}}function o(){k.id=setTimeout(function(){k.fn()},j)}if(p){k.fn=function(q){if(typeof p==="string"){p=g[p]}p.apply(m,d.call(n,i))===true&&!q?o():e()};o()}else{if(k.fn){j===undefined?e():k.fn(j===false);return true}else{e()}}}})(jQuery);

/* Infinite Scroll */

var pInfScrLoading = false;
var pInfScrDelay = 100;

function pInfScrExecute() {
  if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
    var loadingImage;
    pInfScrNode = $('.more').last();	
    pInfScrURL = $('.more a').last().attr("href");
    if(!pInfScrLoading && pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
          loadingImage = pInfScrNode.clone().empty().append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
          loadingImage.insertAfter(pInfScrNode);
          pInfScrNode.hide();
        },
        success: function(data) {
     
     // remove loading feedback
          pInfScrNode.next().remove();
          
          var newBlogPage = $(data).find(".blog-content");
          if(newBlogPage != null){
          	newBlogPage.insertBefore( $("#blog-list-foot") );
            
            if(screen.width > 1020) {
            
            $.each($(".blog-container .blog-content"), function(index, element){
              
              if(index == $(".blog-container .blog-content").length-1){
            	$(element).css("min-height", "1400px");
              } else {
              	$(element).css("min-height", "500px");
              }
            });
              
            } else if (screen.width <= 1020 && screen.width > 764) {
              
              $.each($(".blog-container .blog-content"), function(index, element){
              
              if(index == $(".blog-container .blog-content").length-1){
            	$(element).css("min-height", "1200px");
              } else {
              	$(element).css("min-height", "400px");
              }
              });
            
            } else if (screen.width <= 764 && screen.width > 480) {
              
              $.each($(".blog-container .blog-content"), function(index, element){
              
              if(index == $(".blog-container .blog-content").length-1){
            	$(element).css("min-height", "2000px");
              } else {
              	$(element).css("min-height", "400px");
              }
              });
            
            } else {
            
              $.each($(".blog-container .blog-content"), function(index, element){
              
              if(index == $(".blog-container .blog-content").length-1){
            	$(element).css("min-height", "2240px");
              } else {
              	$(element).css("min-height", "400px");
              }
              });
            }
          }
          
          
          
          var filteredData = $(data).find(".collection-matrix");
          if(filteredData != null) {
          filteredData.insertBefore( $("#product-list-foot") );
          }
          
          loadingImage.remove();					
          pInfScrLoading = false;
          
//           if(filteredData != null) {
//           	$("span.judgeme-badge").html('');

// 			$.getScript( "https://judge.me/shopify.js", function( data, textStatus, jqxhr ) {
//   				judgeme.setUpBadges();
// 		  	});
//           }
        },
        dataType: "html"
      });
    }
  }
}
$(document).ready(function () {
  $(window).scroll(function(){
    $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
    if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      pInfScrDelay = 100;
    }
  });
});


/* Bootstrap tabs */

/* ========================================================
 * bootstrap-tab.js v2.0.4
 * http://twitter.github.com/bootstrap/javascript.html#tabs
 * ========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ======================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* TAB CLASS DEFINITION
  * ==================== */

  var Tab = function ( element ) {
    this.element = $(element)
  }

  Tab.prototype = {

    constructor: Tab

  , show: function () {
      var $this = this.element
        , $ul = $this.closest('ul:not(.dropdown-menu)')
        , selector = $this.attr('data-target')
        , previous
        , $target
        , e

      if (!selector) {
        selector = $this.attr('href')
        selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
      }

      if ( $this.parent('li').hasClass('active') ) return

      previous = $ul.find('.active a').last()[0]

      e = $.Event('show', {
        relatedTarget: previous
      })

      $this.trigger(e)

      if (e.isDefaultPrevented()) return

      $target = $(selector)

      this.activate($this.parent('li'), $ul)
      this.activate($target, $target.parent(), function () {
        $this.trigger({
          type: 'shown'
        , relatedTarget: previous
        })
      })
    }

  , activate: function ( element, container, callback) {
      var $active = container.find('> .active')
        , transition = callback
            && $.support.transition
            && $active.hasClass('fade')

      function next() {
        $active
          .removeClass('active')
          .find('> .dropdown-menu > .active')
          .removeClass('active')

        element.addClass('active')

        if (transition) {
          element[0].offsetWidth // reflow for transition
          element.addClass('in')
        } else {
          element.removeClass('fade')
        }

        if ( element.parent('.dropdown-menu') ) {
          element.closest('li.dropdown').addClass('active')
        }

        callback && callback()
      }

      transition ?
        $active.one($.support.transition.end, next) :
        next()

      $active.removeClass('in')
    }
  }


 /* TAB PLUGIN DEFINITION
  * ===================== */

  $.fn.tab = function ( option ) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('tab')
      if (!data) $this.data('tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.tab.Constructor = Tab


 /* TAB DATA-API
  * ============ */

  $(function () {
    $('body').on('click.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]', function (e) {
      e.preventDefault()
      $(this).tab('show')
    })
  })

}(window.jQuery);

/* jTextFill */

; (function($) {
	/**
	* Resizes an inner element's font so that the inner element completely fills the outer element.
	* @author Russ Painter WebDesign@GeekyMonkey.com
	* @version 0.1
	* @param {Object} Options which are maxFontPixels (default=40), innerTag (default='span')
	* @return All outer elements processed
	* @example <div class='mybigdiv filltext'><span>My Text To Resize</span></div>
	*/
	$.fn.textfill = function(options) {
		var defaults = {
			maxFontPixels: 40,
			innerTag: 'span'
		};
		var Opts = jQuery.extend(defaults, options);
		return this.each(function() {
			var fontSize = Opts.maxFontPixels;
			var ourText = $(Opts.innerTag + ':visible:first', this);
			var maxHeight = $(this).height();
			var maxWidth = $(this).width();
			var textHeight;
			var textWidth;
			do {
				ourText.css('font-size', fontSize);
				textHeight = ourText.height();
				textWidth = ourText.width();
				fontSize = fontSize - 1;
			} while ((textHeight > maxHeight || textWidth > maxWidth) && fontSize > 3);
		});
	};
})(jQuery);

$(document).ready(function() {
	$(".fancybox").fancybox({
		'transitionIn'	: 'elastic',
		'transitionOut'	: 'elastic',
		'overlayColor'		: '#111',
		'overlayOpacity'	: 0.85,
		'arrows' : true
	});
  
  $('.container').on('focusin', function (e) {
	$(".fancybox-iframe").fancybox({
		'width'				: 770,
		'height'			: '90%',
        'autoScale'     	: false,
        'transitionIn'		: 'none',
		'transitionOut'		: 'none',
		'type'				: 'iframe'
	});    
  });
  
	$("#quantity").change(function() {
		quantval($(this).val());
	});

	$("#engraving-text").focusin(function() {
			$("#engraving-example").addClass('focus');
      $('#engraving-example').textfill({ maxFontPixels: 150 });
	});
	$("#engraving-text").focusout(function() {
		if ($("#engraving-example").hasClass('focus')) {
			$("#engraving-example").removeClass('focus');
		}
	});
  
	$('input[name="properties[Font]"]').click(function() {
			$("#engraving-example").removeClass().addClass('custom-text-example');
			$("#engraving-example").addClass($(this).val());
      $("#engraving-text").attr('class', 'font-sample');
      $("#engraving-text").addClass('font-'+$(this).val());
	});

  	$('select[id="product-select-option-0"]').change(function() {
		if ($(this).val() !== "") {
			$("#primary-image").removeClass().addClass($(this).val());
		}
	});

  
	$('#engraving-example').textfill({ maxFontPixels: 150 });

	$('#engraving-text').keyup(function() {
		$('#engraving-example span').html(this.value);
		$('#engraving-example').textfill({ maxFontPixels: 150 });
	});

   
  
  // ---

  $("#printing-text").focusin(function() {
      $("#printing-example").addClass('focus');
      $('#printing-example').textfill({ maxFontPixels: 150 });
  });
  $("#printing-text").focusout(function() {
    if ($("#printing-example").hasClass('focus')) {
      $("#printing-example").removeClass('focus');
    }
  });
  $('select[name="properties[printed_font]"]').change(function() {
    if ($(this).val() !== "") {
      $("#printing-example").removeClass().addClass('custom-text-example');
      $("#printing-example").addClass($(this).val());
      $('#printing-example').textfill({ maxFontPixels: 150 });
      $('#printing-text').focus();
    }
  });

  $('#printing-example').textfill({ maxFontPixels: 150 });

  $('#printing-text').keyup(function() {
    $('#printing-example span').html(this.value);
    $('#printing-example').textfill({ maxFontPixels: 150 });
  });

});

function readURL(input) {
        
        if (input.files && (input.files[0])) {
          
          
            var reader = new FileReader();
			
            reader.onload = function (e) {
               	/*$('#custom-image-left')
                    .attr('src', e.target.result).addClass('show');*/
              /* console.log("Data Image : "+ e.target.result); */
              $('#engraving-placeholder-left')
                    .css('background-image', "url("+e.target.result+")").addClass('show');
              	
            };

            reader.readAsDataURL(input.files[0]);
        }
       
  		
    }
/** TODO Ananthi's notes: - optimise code here: make readURL and readURL2 as a single function**/
function readURL2(input) {
        
        if (input.files && (input.files[0])) {
          
            var reader = new FileReader();
			
            reader.onload = function (e) {
                
              	/*$('#custom-image-right')
                    .attr('src', e.target.result).addClass('show');*/
              $('#engraving-placeholder-right')
                    .css('background-image', "url("+e.target.result+")").addClass('show');
              	
            };

            reader.readAsDataURL(input.files[0]);
        }
        
    }



function quantval(qty) {
  if (typeof quantities !== 'undefined') {
    $.each(quantities, function(key, value) {
      if (value.upper !== false && qty >= value.lower && qty <= value.upper) {
        // Set the hidden variant id
        // Calculate price * quantity and set span
        // return false
        var price = (value.price * qty).toFixed(2);
        var output_price = "$" + price.toString().replace(".", "<sup>.") + " <span class=\"smaller\">AUD</span><span class=\"gst\">Inc. GST</span></sup>";
        $("#qvarid").val(key);
        $("#product-actions .price").html(output_price);
        return false;
      } else if (value["upper"] === false && qty >= value["lower"]) {
        var price = (value.price * qty).toFixed(2);
        var output_price = "$" + price.toString().replace(".", "<sup>.") + " <span class=\"smaller\">AUD</span><span class=\"gst\">Inc. GST</span></sup>";
        $("#qvarid").val(key);
        $("#product-actions .price").html(output_price);
        return false;
      }
    });
  }
}

/* Bootstrap animations */
/* ===================================================
 * bootstrap-transition.js v2.0.4
 * http://twitter.github.com/bootstrap/javascript.html#transitions
 * ===================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  $(function () {

    "use strict"; // jshint ;_;


    /* CSS TRANSITION SUPPORT (http://www.modernizr.com/)
     * ======================================================= */

    $.support.transition = (function () {

      var transitionEnd = (function () {

        var el = document.createElement('bootstrap')
          , transEndEventNames = {
               'WebkitTransition' : 'webkitTransitionEnd'
            ,  'MozTransition'    : 'transitionend'
            ,  'OTransition'      : 'oTransitionEnd'
            ,  'msTransition'     : 'MSTransitionEnd'
            ,  'transition'       : 'transitionend'
            }
          , name

        for (name in transEndEventNames){
          if (el.style[name] !== undefined) {
            return transEndEventNames[name]
          }
        }

      }())

      return transitionEnd && {
        end: transitionEnd
      }

    })()

  })

}(window.jQuery);
/*
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* TOOLTIP PUBLIC CLASS DEFINITION
  * =============================== */

  var Tooltip = function (element, options) {
    this.init('tooltip', element, options)
  }

  Tooltip.prototype = {

    constructor: Tooltip

  , init: function (type, element, options) {
      var eventIn
        , eventOut

      this.type = type
      this.$element = $(element)
      this.options = this.getOptions(options)
      this.enabled = true

      if (this.options.trigger != 'manual') {
        eventIn  = this.options.trigger == 'hover' ? 'mouseenter' : 'focus'
        eventOut = this.options.trigger == 'hover' ? 'mouseleave' : 'blur'
        this.$element.on(eventIn, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut, this.options.selector, $.proxy(this.leave, this))
      }

      this.options.selector ?
        (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
        this.fixTitle()
    }

  , getOptions: function (options) {
      options = $.extend({}, $.fn[this.type].defaults, options, this.$element.data())

      if (options.delay && typeof options.delay == 'number') {
        options.delay = {
          show: options.delay
        , hide: options.delay
        }
      }

      return options
    }

  , enter: function (e) {
      var self = $(e.currentTarget)[this.type](this._options).data(this.type)

      if (!self.options.delay || !self.options.delay.show) return self.show()

      clearTimeout(this.timeout)
      self.hoverState = 'in'
      this.timeout = setTimeout(function() {
        if (self.hoverState == 'in') self.show()
      }, self.options.delay.show)
    }

  , leave: function (e) {
      var self = $(e.currentTarget)[this.type](this._options).data(this.type)

      if (this.timeout) clearTimeout(this.timeout)
      if (!self.options.delay || !self.options.delay.hide) return self.hide()

      self.hoverState = 'out'
      this.timeout = setTimeout(function() {
        if (self.hoverState == 'out') self.hide()
      }, self.options.delay.hide)
    }

  , show: function () {
      var $tip
        , inside
        , pos
        , actualWidth
        , actualHeight
        , placement
        , tp

      if (this.hasContent() && this.enabled) {
        $tip = this.tip()
        this.setContent()

        if (this.options.animation) {
          $tip.addClass('fade')
        }

        placement = typeof this.options.placement == 'function' ?
          this.options.placement.call(this, $tip[0], this.$element[0]) :
          this.options.placement

        inside = /in/.test(placement)

        $tip
          .remove()
          .css({ top: 0, left: 0, display: 'block' })
          .appendTo(inside ? this.$element : document.body)

        pos = this.getPosition(inside)

        actualWidth = $tip[0].offsetWidth
        actualHeight = $tip[0].offsetHeight

        switch (inside ? placement.split(' ')[1] : placement) {
          case 'bottom':
            tp = {top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2}
            break
          case 'top':
            tp = {top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2}
            break
          case 'left':
            tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth}
            break
          case 'right':
            tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width}
            break
        }

        $tip
          .css(tp)
          .addClass(placement)
          .addClass('in')
      }
    }

  , isHTML: function(text) {
      // html string detection logic adapted from jQuery
      return typeof text != 'string'
        || ( text.charAt(0) === "<"
          && text.charAt( text.length - 1 ) === ">"
          && text.length >= 3
        ) || /^(?:[^<]*<[\w\W]+>[^>]*$)/.exec(text)
    }

  , setContent: function () {
      var $tip = this.tip()
        , title = this.getTitle()

      $tip.find('.tooltip-inner')[this.isHTML(title) ? 'html' : 'text'](title)
      $tip.removeClass('fade in top bottom left right')
    }

  , hide: function () {
      var that = this
        , $tip = this.tip()

      $tip.removeClass('in')

      function removeWithAnimation() {
        var timeout = setTimeout(function () {
          $tip.off($.support.transition.end).remove()
        }, 500)

        $tip.one($.support.transition.end, function () {
          clearTimeout(timeout)
          $tip.remove()
        })
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        removeWithAnimation() :
        $tip.remove()
    }

  , fixTitle: function () {
      var $e = this.$element
      if ($e.attr('title') || typeof($e.attr('data-original-title')) != 'string') {
        $e.attr('data-original-title', $e.attr('title') || '').removeAttr('title')
      }
    }

  , hasContent: function () {
      return this.getTitle()
    }

  , getPosition: function (inside) {
      return $.extend({}, (inside ? {top: 0, left: 0} : this.$element.offset()), {
        width: this.$element[0].offsetWidth
      , height: this.$element[0].offsetHeight
      })
    }

  , getTitle: function () {
      var title
        , $e = this.$element
        , o = this.options

      title = $e.attr('data-original-title')
        || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

      return title
    }

  , tip: function () {
      return this.$tip = this.$tip || $(this.options.template)
    }

  , validate: function () {
      if (!this.$element[0].parentNode) {
        this.hide()
        this.$element = null
        this.options = null
      }
    }

  , enable: function () {
      this.enabled = true
    }

  , disable: function () {
      this.enabled = false
    }

  , toggleEnabled: function () {
      this.enabled = !this.enabled
    }

  , toggle: function () {
      this[this.tip().hasClass('in') ? 'hide' : 'show']()
    }

  }


 /* TOOLTIP PLUGIN DEFINITION
  * ========================= */

  $.fn.tooltip = function ( option ) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('tooltip')
        , options = typeof option == 'object' && option
      if (!data) $this.data('tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.tooltip.Constructor = Tooltip

  $.fn.tooltip.defaults = {
    animation: true
  , placement: 'top'
  , selector: false
  , template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
  , trigger: 'hover'
  , title: ''
  , delay: 0
  }

}(window.jQuery);

/* ===========================================================
 * bootstrap-popover.js v2.0.4
 * http://twitter.github.com/bootstrap/javascript.html#popovers
 * ===========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* POPOVER PUBLIC CLASS DEFINITION
  * =============================== */

  var Popover = function ( element, options ) {
    this.init('popover', element, options)
  }


  /* NOTE: POPOVER EXTENDS BOOTSTRAP-TOOLTIP.js
     ========================================== */

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype, {

    constructor: Popover

  , setContent: function () {
      var $tip = this.tip()
        , title = this.getTitle()
        , content = this.getContent()

      $tip.find('.popover-title')[this.isHTML(title) ? 'html' : 'text'](title)
      $tip.find('.popover-content > *')[this.isHTML(content) ? 'html' : 'text'](content)

      $tip.removeClass('fade top bottom left right in')
    }

  , hasContent: function () {
      return this.getTitle() || this.getContent()
    }

  , getContent: function () {
      var content
        , $e = this.$element
        , o = this.options

      content = $e.attr('data-content')
        || (typeof o.content == 'function' ? o.content.call($e[0]) :  o.content)

      return content
    }

  , tip: function () {
      if (!this.$tip) {
        this.$tip = $(this.options.template)
      }
      return this.$tip
    }

  })

  
// jQuery Plugin LivingFade
// A plugin to fade in or out a selection of elements in a living way (randomly delayed and with random speeds)
// Version 0.2 - 24. 7. 2011
// by Fredi Bach


    $.livingFade = function(element, options) {

        var defaults = {
			maxDelay: 1000,
			minSpeed: 500,
			maxSpeed: 250,
			fadeTo: 0,
			affected: '.fademe',
			onFinish: function() {}
        }
		
        var plugin = this;

        plugin.settings = {}
		
        var $element = $(element),
             element = element;
		
        plugin.init = function() {
            plugin.settings = $.extend({}, defaults, options);
			
			var cnt = 0;
			
			$element.children(plugin.settings.affected).each( function(){
				var delay = Math.ceil( Math.random() * plugin.settings.maxDelay );
				var speed = plugin.settings.maxSpeed + Math.ceil( Math.random() * ( plugin.settings.minSpeed - plugin.settings.maxSpeed ) );
				
				cnt++;
				
				$(this).delay(delay).fadeTo(speed, plugin.settings.fadeTo, function(){
					
					cnt--;
					
					if (cnt == 0){
						plugin.settings.onFinish();
					}
				});
			});
        }
		
        plugin.init();

    }

    $.fn.livingFade = function(options) {

        return this.each(function() {
            var plugin = new $.livingFade(this, options);
			$(this).data('livingFade', plugin);
        });

    }


  

 /* POPOVER PLUGIN DEFINITION
  * ======================= */

  $.fn.popover = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('popover')
        , options = typeof option == 'object' && option
      if (!data) $this.data('popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.popover.Constructor = Popover

  $.fn.popover.defaults = $.extend({} , $.fn.tooltip.defaults, {
    placement: 'right'
  , content: ''
  , template: '<div class="popover"><div class="arrow"></div><div class="popover-inner"><h3 class="popover-title"></h3><div class="popover-content"><p></p></div></div></div>'
  })

}(window.jQuery);
/* =============================================================
 * bootstrap-collapse.js v2.0.4
 * http://twitter.github.com/bootstrap/javascript.html#collapse
 * =============================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


!function ($) {

  "use strict"; // jshint ;_;


 /* COLLAPSE PUBLIC CLASS DEFINITION
  * ================================ */

  var Collapse = function (element, options) {
    this.$element = $(element)
    this.options = $.extend({}, $.fn.collapse.defaults, options)

    if (this.options.parent) {
      this.$parent = $(this.options.parent)
    }

    this.options.toggle && this.toggle()
  }

  Collapse.prototype = {

    constructor: Collapse

  , dimension: function () {
      var hasWidth = this.$element.hasClass('width')
      return hasWidth ? 'width' : 'height'
    }

  , show: function () {
      var dimension
        , scroll
        , actives
        , hasData

      if (this.transitioning) return

      dimension = this.dimension()
      scroll = $.camelCase(['scroll', dimension].join('-'))
      actives = this.$parent && this.$parent.find('> .accordion-group > .in')

      if (actives && actives.length) {
        hasData = actives.data('collapse')
        if (hasData && hasData.transitioning) return
        actives.collapse('hide')
        hasData || actives.data('collapse', null)
      }

      this.$element[dimension](0)
      this.transition('addClass', $.Event('show'), 'shown')
      this.$element[dimension](this.$element[0][scroll])
    }

  , hide: function () {
      var dimension
      if (this.transitioning) return
      dimension = this.dimension()
      this.reset(this.$element[dimension]())
      this.transition('removeClass', $.Event('hide'), 'hidden')
      this.$element[dimension](0)
    }

  , reset: function (size) {
      var dimension = this.dimension()

      this.$element
        .removeClass('collapse')
        [dimension](size || 'auto')
        [0].offsetWidth

      this.$element[size !== null ? 'addClass' : 'removeClass']('collapse')

      return this
    }

  , transition: function (method, startEvent, completeEvent) {
      var that = this
        , complete = function () {
            if (startEvent.type == 'show') that.reset()
            that.transitioning = 0
            that.$element.trigger(completeEvent)
          }

      this.$element.trigger(startEvent)

      if (startEvent.isDefaultPrevented()) return

      this.transitioning = 1

      this.$element[method]('in')

      $.support.transition && this.$element.hasClass('collapse') ?
        this.$element.one($.support.transition.end, complete) :
        complete()
    }

  , toggle: function () {
      this[this.$element.hasClass('in') ? 'hide' : 'show']()
    }

  }


 /* COLLAPSIBLE PLUGIN DEFINITION
  * ============================== */

  $.fn.collapse = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('collapse')
        , options = typeof option == 'object' && option
      if (!data) $this.data('collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.collapse.defaults = {
    toggle: true
  }

  $.fn.collapse.Constructor = Collapse


 /* COLLAPSIBLE DATA-API
  * ==================== */

  $(function () {
    $('body').on('click.collapse.data-api', '[data-toggle=collapse]', function ( e ) {
      var $this = $(this), href
        , target = $this.attr('data-target')
          || e.preventDefault()
          || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') //strip for ie7
        , option = $(target).data('collapse') ? 'toggle' : $this.data()
      $(target).collapse(option)
    })
  })

}(window.jQuery);



/* ==========================================================
 * bootstrap-carousel.js v2.3.0
 * http://twitter.github.com/bootstrap/javascript.html#carousel
 * ==========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* CAROUSEL CLASS DEFINITION
  * ========================= */

  var Carousel = function (element, options) {
    this.$element = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options = options
    this.options.pause == 'hover' && this.$element
      .on('mouseenter', $.proxy(this.pause, this))
      .on('mouseleave', $.proxy(this.cycle, this))
  }

  Carousel.prototype = {

    cycle: function (e) {
      if (!e) this.paused = false
      if (this.interval) clearInterval(this.interval);
      this.options.interval
        && !this.paused
        && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
      return this
    }

  , getActiveIndex: function () {
      this.$active = this.$element.find('.item.active')
      this.$items = this.$active.parent().children()
      return this.$items.index(this.$active)
    }

  , to: function (pos) {
      var activeIndex = this.getActiveIndex()
        , that = this

      if (pos > (this.$items.length - 1) || pos < 0) return

      if (this.sliding) {
        return this.$element.one('slid', function () {
          that.to(pos)
        })
      }

      if (activeIndex == pos) {
        return this.pause().cycle()
      }

      return this.slide(pos > activeIndex ? 'next' : 'prev', $(this.$items[pos]))
    }

  , pause: function (e) {
      if (!e) this.paused = true
      if (this.$element.find('.next, .prev').length && $.support.transition.end) {
        this.$element.trigger($.support.transition.end)
        this.cycle()
      }
      clearInterval(this.interval)
      this.interval = null
      return this
    }

  , next: function () {
      if (this.sliding) return
      return this.slide('next')
    }

  , prev: function () {
      if (this.sliding) return
      return this.slide('prev')
    }

  , slide: function (type, next) {
      var $active = this.$element.find('.item.active')
        , $next = next || $active[type]()
        , isCycling = this.interval
        , direction = type == 'next' ? 'left' : 'right'
        , fallback  = type == 'next' ? 'first' : 'last'
        , that = this
        , e

      this.sliding = true

      isCycling && this.pause()

      $next = $next.length ? $next : this.$element.find('.item')[fallback]()

      e = $.Event('slide', {
        relatedTarget: $next[0]
      , direction: direction
      })

      if ($next.hasClass('active')) return

      if (this.$indicators.length) {
        this.$indicators.find('.active').removeClass('active')
        this.$element.one('slid', function () {
          var $nextIndicator = $(that.$indicators.children()[that.getActiveIndex()])
          $nextIndicator && $nextIndicator.addClass('active')
        })
      }

      if ($.support.transition && this.$element.hasClass('slide')) {
        this.$element.trigger(e)
        if (e.isDefaultPrevented()) return
        $next.addClass(type)
        $next[0].offsetWidth // force reflow
        $active.addClass(direction)
        $next.addClass(direction)
        this.$element.one($.support.transition.end, function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () { that.$element.trigger('slid') }, 0)
        })
      } else {
        this.$element.trigger(e)
        if (e.isDefaultPrevented()) return
        $active.removeClass('active')
        $next.addClass('active')
        this.sliding = false
        this.$element.trigger('slid')
      }

      isCycling && this.cycle()

      return this
    }

  }

  
  

 /* CAROUSEL PLUGIN DEFINITION
  * ========================== */

  var old = $.fn.carousel

  $.fn.carousel = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('carousel')
        , options = $.extend({}, $.fn.carousel.defaults, typeof option == 'object' && option)
        , action = typeof option == 'string' ? option : options.slide
      if (!data) $this.data('carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  $.fn.carousel.defaults = {
    interval: 5000
  , pause: 'hover'
  }

  $.fn.carousel.Constructor = Carousel


 /* CAROUSEL NO CONFLICT
  * ==================== */

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }

 /* CAROUSEL DATA-API
  * ================= */

  $(document).on('click.carousel.data-api', '[data-slide], [data-slide-to]', function (e) {
    var $this = $(this), href
      , $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) //strip for ie7
      , options = $.extend({}, $target.data(), $this.data())
      , slideIndex

    $target.carousel(options)

    if (slideIndex = $this.attr('data-slide-to')) {
      $target.data('carousel').pause().to(slideIndex).cycle()
    }

    e.preventDefault()
  })

}(window.jQuery);



(function($) {

  // Landing page slider
  $('#landing-template .landing-thumbnail-link').on('click', function(e) {
    e.preventDefault();
    $('#landing-template .landing-slider-primary-image img').prop('src', $(this).prop('href'));
  });
  $('#landing-quote-artwork-label').on('click', function (e) {
    $('#landing-quote-artwork').trigger('click');
  });
  $('.carousel').carousel({interval:4000});

  var imageCount = 1;
  if ($('#image-upload-container').length) {
   	$('#image-upload-container').append('<a id="image-upload-add-link" href="#">Add another image</a>');
    $('#image-upload-add-link').on('click', function(e) {
    	e.preventDefault();
     	$('#image-upload-add-link').before('<div class="controls"><input type="file" class="upload" id="image_upload" name="properties[Image'+imageCount+']" value="" /></div>');
      imageCount++;
    });
  }

  var popupStack = 0;

  $('#more_artwork').on('click', function (e) {
    e.preventDefault();
    $('.artwork-container').append('<div class="form-field"><input type="file" class="input-file" id="artwork" name="artwork[]"></div>');
  });

//   /* Add to Cart Button hit */
//   $('.add-to-cart').on('click', function(e) {

//   		e.preventDefault();

// 		if ($('#product-actions :file').length > 0)
// 		{
// 			//$('html, body').animate({scrollTop: '0px'}, 300);

// 			var cartButton = e.currentTarget;

// 			$('#checkout').popover({
// 			title:     'Adding to the cart',
//       		content:   '<div class="popover-loading"></div>',
// 			trigger:   'manual',
// 			placement: 'bottom'
// 			});

// 			$('#checkout').popover('show');
// 			$(cartButton).addClass('add-to-cart-disabled').val('Adding...').attr('disabled', 'disabled');

// 			return $('#product-actions').submit();
// 		}

//     /* Slide to top */
//     //$('html, body').animate({scrollTop: '0px'}, 300);

//     var cartButton = e.currentTarget;

//     $('#checkout').popover({
//       title:     'Adding to the cart',
//       content:   '<div class="popover-loading"></div>',
//       trigger:   'manual',
//       placement: 'bottom'
//     });


// 		popupStack++;
//     $('#checkout').popover('show');
//     $(cartButton).addClass('add-to-cart-disabled').val('Adding...').attr('disabled', 'disabled');

//     /* AJAX Call to Shopify */
//     $.post(
//       '/cart/add.js',
//       $('#product-actions').serialize(),
//       function(data, code, resp) {

//         $('#checkout').data('popover').options.title = '<strong style="color:#218fce;">Added to the cart!</strong>';
//         $('#checkout').data('popover').options.content = '<strong>'+data.title+' was added to your cart.</strong>';

//         $.getJSON('/cart.js', function(data) {

//           // Update popup and cart item count
//           $('#checkout .count').html(data.item_count);
//           $('#checkout').data('popover').show();

//           // Reset add to cart button
//           $(cartButton).removeClass('add-to-cart-disabled').val('Add to Cart').attr('disabled', null);

//           // Hide the popover in 1.5 seconds
//           setTimeout(function() {
// 				popupStack--;
// 				if (popupStack <= 0) {
// 					$('#checkout').popover('hide');
// 					$('#checkout').data('popover', null);
// 					popupStack = 0;
//           if(typeof(upsell_offer) === "function"){ upsell_offer(); }
// 				}
//           }, 1500);
//         });
//       },
//       'json'
//     ).error(function(data, code, resp) {
//       var errorObj = JSON.parse(data.responseText);
//       $('#checkout').data('popover').options.title = '<strong style="color:red;">Cart Error!</strong>';
//       $('#checkout').data('popover').options.content = '<strong>'+errorObj.description+'</strong>';
//       $(cartButton).removeClass('add-to-cart-disabled').val('Add to Cart').attr('disabled', null);
//       $('#checkout').data('popover').show();
//       // Hide the popover in 2.5 seconds
//       setTimeout(function() {
// 			popupStack--;
// 			if (popupStack <= 0) {
// 				$('#checkout').popover('hide');
// 				$('#checkout').data('popover', null);
// 				popupStack = 0;
// 			}
//       }, 2500);
//     });
//   });
  
  /* Add to Cart Button from collection */
//   $('.add-to-cart-collection').on('click', function(e) {
//   		e.preventDefault();

// 		if ($('#product-actions :file').length > 0)
// 		{

// 			var cartButton = e.currentTarget;

// 			$('#checkout').popover({
// 			title:     'Adding to the cart',
//       		content:   '<div class="popover-loading"></div>',
// 			trigger:   'manual',
// 			placement: 'bottom'
// 			});

// 			$('#checkout').popover('show');
// 			$(cartButton).addClass('add-to-cart-disabled').val('Adding...').attr('disabled', 'disabled');

// 			return $('#product-actions').submit();
// 		}


//     var cartButton = e.currentTarget;

//     $('#checkout').popover({
//       title:     'Adding to the cart',
//       content:   '<div class="popover-loading"></div>',
//       trigger:   'manual',
//       placement: 'bottom'
//     });


// 		popupStack++;
//     $('#checkout').popover('show');
//     $(cartButton).addClass('add-to-cart-disabled').val('Adding...').attr('disabled', 'disabled');

//     /* AJAX Call to Shopify */
//     $.post(
//       '/cart/add.js',
//       {id: this.previousElementSibling.value, quantity: 1},
//       function(data, code, resp) {

//         $('#checkout').data('popover').options.title = '<strong style="color:#218fce;">Added to the cart!</strong>';
//         $('#checkout').data('popover').options.content = '<strong>'+data.title+' was added to your cart.</strong>';

//         $.getJSON('/cart.js', function(data) {

//           // Update popup and cart item count
//           $('#checkout .count').html(data.item_count);
//           $('#checkout').data('popover').show();

//           // Reset add to cart button
//           $(cartButton).removeClass('add-to-cart-disabled').val('Added to cart').attr('disabled', null);

//           // Hide the popover in 1.5 seconds
//           setTimeout(function() {
// 				popupStack--;
// 				if (popupStack <= 0) {
// 					$('#checkout').popover('hide');
// 					$('#checkout').data('popover', null);
// 					popupStack = 0;
//           if(typeof(upsell_offer) === "function"){ upsell_offer(); }
// 				}
//           }, 1500);
//         });
//       },
//       'json'
//     ).error(function(data, code, resp) {
//       var errorObj = JSON.parse(data.responseText);
//       $('#checkout').data('popover').options.title = '<strong style="color:red;">Cart Error!</strong>';
//       $('#checkout').data('popover').options.content = '<strong>'+errorObj.description+'</strong>';
//       $(cartButton).removeClass('add-to-cart-disabled').val('Add to Cart').attr('disabled', null);
//       $('#checkout').data('popover').show();
//       // Hide the popover in 2.5 seconds
//       setTimeout(function() {
// 			popupStack--;
// 			if (popupStack <= 0) {
// 				$('#checkout').popover('hide');
// 				$('#checkout').data('popover', null);
// 				popupStack = 0;
// 			}
//       }, 2500);
//     });
//   });

  document.domain = 'tiesncuffs.com.au';
})(window.jQuery);



!(function($) {
  // Regex to validate email
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  // Catch Quote form submission
  $('form[action="http://services.tiesncuffs.com.au/quote/direct"]').on('submit', function(e) {
    e.preventDefault();
    var quoteForm = e.currentTarget;

    // Check fields
    var first_name = $('[name="first_name"]', quoteForm).val();
    var last_name  = $('[name="last_name"]', quoteForm).val();
    var email      = $('[name="email"]', quoteForm).val();
    var phone      = $('[name="phone"]', quoteForm).val();
    var enquiry    = $('[name="enquiry"]', quoteForm).val();

    if (!first_name || first_name.length === 0) {
      alert('Please enter your first name');
      return $('[name="first_name"]', quoteForm).focus();
    }
    // if (!last_name || last_name.length === 0) {
    //   alert('Please enter your last name');
    //   return $('[name="last_name"]', quoteForm).focus();
    // }
    if (!email || email.length === 0) {
      alert('Please enter your email address');
      return $('[name="email"]', quoteForm).focus();
    }
    if (!re.test(email)) {
      alert('Invalid email address');
      return $('[name="email"]', quoteForm).focus();
    }

    if (!phone || phone.length === 0) {
      alert('Please enter your phone number');
      return $('[name="phone"]', quoteForm).focus();
    }
    if ($('[name="enquiry"]', quoteForm).length &&  (!enquiry || enquiry.length === 0)) {
      alert('Please enter your enquiry');
      return $('[name="enquiry"]', quoteForm).focus();
    }

    hj('formSubmitSuccessful');
    quoteForm.submit();

  })

  
  
})(window.jQuery)
